/**
 * @fileoverview gRPC-Web generated client stub for history
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.3
// source: src/grpc/history.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.history = require('./history_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.history.HistoryClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.history.HistoryPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.history.OHLCRequest,
 *   !proto.history.OHLCReply>}
 */
const methodDescriptor_History_GetOHLC = new grpc.web.MethodDescriptor(
  '/history.History/GetOHLC',
  grpc.web.MethodType.UNARY,
  proto.history.OHLCRequest,
  proto.history.OHLCReply,
  /**
   * @param {!proto.history.OHLCRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.history.OHLCReply.deserializeBinary
);


/**
 * @param {!proto.history.OHLCRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.history.OHLCReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.history.OHLCReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.history.HistoryClient.prototype.getOHLC =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/history.History/GetOHLC',
      request,
      metadata || {},
      methodDescriptor_History_GetOHLC,
      callback);
};


/**
 * @param {!proto.history.OHLCRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.history.OHLCReply>}
 *     Promise that resolves to the response
 */
proto.history.HistoryPromiseClient.prototype.getOHLC =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/history.History/GetOHLC',
      request,
      metadata || {},
      methodDescriptor_History_GetOHLC);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.history.OHLCV2Request,
 *   !proto.history.OHLCReply>}
 */
const methodDescriptor_History_GetOHLCV2 = new grpc.web.MethodDescriptor(
  '/history.History/GetOHLCV2',
  grpc.web.MethodType.UNARY,
  proto.history.OHLCV2Request,
  proto.history.OHLCReply,
  /**
   * @param {!proto.history.OHLCV2Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.history.OHLCReply.deserializeBinary
);


/**
 * @param {!proto.history.OHLCV2Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.history.OHLCReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.history.OHLCReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.history.HistoryClient.prototype.getOHLCV2 =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/history.History/GetOHLCV2',
      request,
      metadata || {},
      methodDescriptor_History_GetOHLCV2,
      callback);
};


/**
 * @param {!proto.history.OHLCV2Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.history.OHLCReply>}
 *     Promise that resolves to the response
 */
proto.history.HistoryPromiseClient.prototype.getOHLCV2 =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/history.History/GetOHLCV2',
      request,
      metadata || {},
      methodDescriptor_History_GetOHLCV2);
};


module.exports = proto.history;

